<mat-table class="table" [dataSource]="systems">
  <ng-container matColumnDef="selected">
    <mat-header-cell class="header-cell" *matHeaderCellDef>
      @if (allSystemsSelected) {
      <div class="select-all" (click)="unselectAll()">Unselect all</div>
      } @else {
      <div class="select-all" (click)="selectAll()">Select all</div>
      }
    </mat-header-cell>
    <mat-cell class="name" *matCellDef="let system">
      <input type="checkbox" [(ngModel)]="system.selected" (ngModelChange)="onCheckboxChange(system)" />
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell class="header-cell" *matHeaderCellDef>System name</mat-header-cell>
    <mat-cell class="name" *matCellDef="let system">
      {{ system.name }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell class="header-cell" *matHeaderCellDef>Status</mat-header-cell>
    <mat-cell class="status" *matCellDef="let system"> <app-status-badge [status]="system.status"></app-status-badge> </mat-cell>
  </ng-container>

  <ng-container matColumnDef="progress">
    <mat-header-cell class="header-cell" *matHeaderCellDef>Progress</mat-header-cell>
    <mat-cell *matCellDef="let system">
      <span class="emphasized-text">{{ system.numQuestionsAnswered }}/{{ system.numQuestionsTotal }} </span>
      &nbsp;
      <span class="text">parameters</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dates">
    <mat-header-cell class="header-cell" *matHeaderCellDef>Dates</mat-header-cell>
    <mat-cell *matCellDef="let system">
      <div>
        <div>
          <span class="emphasized-text">Start: </span>
          <span class="text">{{ system.createdAt.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) }}</span>
        </div>
        <div>
          <span class="emphasized-text">Modified: </span>
          <span class="text">{{ system.updatedAt.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) }}</span>
        </div>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="action">
    <mat-header-cell class="header-cell" *matHeaderCellDef>Action</mat-header-cell>
    <mat-cell *matCellDef="let system">
      @if (system.status == 'not started') {
      <button class="iconf-btn-filled iconf-btn-custom" [routerLink]="['system', system.id, 'questionnaire']">start configure</button>
      } @if (system.status == 'in progress') {
      <button class="iconf-btn-filled iconf-btn-custom" [routerLink]="['system', system.id, 'questionnaire']">resume</button>
      } @if (system.status == 'completed') {
      <button class="iconf-btn-filled iconf-btn-custom" [routerLink]="['system', system.id, 'recommendation']">summary</button>
      }
    </mat-cell>
  </ng-container>

  <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row class="project-row" *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
